import React from 'react';
import { useTranslation } from 'react-i18next';
import { PcrBullets } from '../../../../models/PcrNextPresentation';
import styles from './PcrBulletsComponent.module.scss';

type Props = {
  data?: any[];
  bulletsData: PcrBullets[];
  disabled?: boolean;
};
export const PcrBulletsComponent = ({ bulletsData, disabled = false, data }: Props) => {
  const { bulletsContainer, item, dot, dotDisabled, itemText, itemTextDisabled } = styles;
  const { t } = useTranslation();
  const hasNoData = disabled || !data?.length || data.every(item => Number(item.value) === 0);

  return (
    <div className={bulletsContainer}>
      {bulletsData.map(d => {
        return (
          <div className={item} key={d.bulletText}>
            <i
              className={hasNoData ? dotDisabled : dot}
              style={{ backgroundColor: hasNoData ? undefined : d.bulletColor }}
            />
            <p className={hasNoData ? itemTextDisabled : itemText}> {t(d.bulletText)}</p>
          </div>
        );
      })}
    </div>
  );
};
